/**
 * Footer component for Jojo & Jocelyn
 * Contains services links, contact info, and business details
 */

import Link from 'next/link';
import { Scissors, Phone, Mail, MapPin, Facebook } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background border-t border-border">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="p-2 bg-primary rounded-lg">
                <Scissors className="h-5 w-5 text-primary-foreground" />
              </div>
              <div>
                <h3 className="text-lg font-bold">Jojo & Jocelyn</h3>
                <p className="text-xs text-background/70 tracking-wider uppercase">
                  Complete Upholstery And Curtain
                </p>
              </div>
            </div>
            <p className="text-sm text-background/80 leading-relaxed">
              Transforming furniture and spaces with expert craftsmanship since 1999.
              Your trusted partner for luxury upholstery and custom window treatments.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-primary">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  href="/portfolio"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  View Portfolio
                </Link>
              </li>
              <li>
                <Link
                  href="/about"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-primary">Get In Touch</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href="tel:09176260243"
                  className="flex items-center gap-3 text-background/80 hover:text-primary transition-colors group"
                >
                  <Phone className="h-4 w-4 group-hover:scale-110 transition-transform" />
                  <span>0917 626 0243</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:jojojocelyn850@gmail.com"
                  className="flex items-center gap-3 text-background/80 hover:text-primary transition-colors group"
                >
                  <Mail className="h-4 w-4 group-hover:scale-110 transition-transform" />
                  <span>jojojocelyn850@gmail.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-background/80">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>
                  Tanza, Cavite<br />
                  Philippines
                </span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.facebook.com/curtain.corner.n.more/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-background/10 hover:bg-primary rounded-full transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background/20 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-background/60">
          <p>
            © {currentYear} Jojo & Jocelyn Complete Upholstery And Curtain Services. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link href="/privacy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link href="/terms" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
